export enum ResponseStatus {
    SUCCESS = 200,
    CREATED = 201,
    NO_CONTENT = 204,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500,
};

export enum ErrorCode {
    OK = 0,

    // 获取*列表失败
    GET_LIST_FAILED = -1,
    // 获取*信息失败
    GET_DETAIL_FAILED = -2,
    // 未找到该*
    NOT_FOUND = -3,
    // ユーザー情報が無効です
    AUTH_INVALID = -4,
    // 创建*失败
    CREATE_FAILED = -5,
    // 更新*信息失败
    UPDATE_FAILED = -6,
    // 删除*失败
    DELETE_FAILED = -7,

    // 密码错误
    PASSWORD_INCORRECT = -8,
    // 密码变更失败
    CHANGE_PASSWORD_FAILED = -9,

    // 文件上传失败
    FILE_UPLOAD_FAILED = -10,
    // 未上传文件
    NO_FILE_UPLOAD = -11,
    // 材料数据导入失败
    MATERIAL_IMPORT_FAILED = -12,
    // 上传材料失败
    UPLOAD_MATERIAL_FAILED = -13,
    // 图片不存在
    IMAGE_NOT_EXIST = -14,
    // 文件不存在
    FILE_NOT_EXIST = -15,
    // アラートメッセージを受信済みとしてマークすることに失敗しました
    MAKE_ALARM_MESSAGE_FAILED = -16,

    //user_id 不能为空
    USER_ID_NULL = -17,
    // 消息发送失败
    SEND_NOTIFICATION_FAILED = -18,

    // 数据导入失败
    IMPORT_CSV_FAILED = -20,
    // 数据导出失败
    EXPORT_CSV_FAILED = -21,

    // 材料与组信息不匹配
    MATERIAL_AND_GROUP_IMFORMATION_NOT_MATCH = -22,
    
    // 部门本部已存在
    DEPARTMENT_HEAD_EXIST = -23,

    DELETE_FAILED_INVENTORY_EXISTS = -24,

    // 已存在
    ALREADY_EXIST = -25,
    
    // 服务器错误
    SERVER_ERROR = -999,
};

export interface ResponseData<T = any> {
    code: ErrorCode;
    message?: string;
    total?: number;
    totalPages?: number;
    currentPage?: number;
    data?: T;
    hasMoreData?: boolean;
}

export interface ImportResponseData {
    code: ErrorCode;
    message?: string;
    totalCount?: number;
    validCount?: number;
    invalidCount?: number;
}

export interface UploadImageResponseData {
    code: ErrorCode;
    message?: string;
    images?: any;
}

export interface ReminderSettingResponseData {
    code: ErrorCode;
    message?: string;
    inventory_id?: string;
    user_id?: string;
    type?: string;
    quantity?: number;
    is_actived?: number;
}